(() => {
  if (customElements.get('flowbox-tab')) return;

  const FLOWBOX_SCRIPT_ID = 'flowbox-js-embed';
  const FLOWBOX_SCRIPT_SRC = 'https://connect.getflowbox.com/flowbox.js';

  function ensureFlowboxQueue() {
    if (window.flowbox) return;

    const queue = function () {
      queue.q.push(arguments);
    };
    queue.q = [];
    window.flowbox = queue;
  }

  function loadFlowboxScript() {
    ensureFlowboxQueue();

    const existingScript = document.getElementById(FLOWBOX_SCRIPT_ID);
    if (existingScript) {
      return existingScript.dataset.loaded === 'true'
        ? Promise.resolve()
        : new Promise((resolve) => {
            existingScript.addEventListener('load', resolve, { once: true });
          });
    }

    return new Promise((resolve) => {
      const script = document.createElement('script');
      const ref = document.scripts[document.scripts.length - 1];

      script.id = FLOWBOX_SCRIPT_ID;
      script.async = true;
      script.src = FLOWBOX_SCRIPT_SRC;
      script.addEventListener(
        'load',
        () => {
          script.dataset.loaded = 'true';
          resolve();
        },
        { once: true }
      );

      ref.parentNode.insertBefore(script, ref);
    });
  }

  function dispatchResizePasses() {
    window.dispatchEvent(new Event('resize'));
    [300, 800, 1500].forEach((delay) => {
      setTimeout(() => window.dispatchEvent(new Event('resize')), delay);
    });
  }

  class FlowboxTab extends HTMLElement {
    constructor() {
      super();
      this.initialized = false;
      this.onAccordionClick = this.onAccordionClick.bind(this);
      this.onIntersect = this.onIntersect.bind(this);
    }

    connectedCallback() {
      this.accordionBtn = this.querySelector('[data-flowbox-accordion]');
      this.panel = this.querySelector('[data-flowbox-panel]');
      this.flowContainer = this.querySelector('[data-flowbox-container]');

      if (!this.accordionBtn || !this.panel || !this.flowContainer) return;

      this.intersectionObserver = new IntersectionObserver(this.onIntersect, {
        threshold: 0.1,
      });
      this.intersectionObserver.observe(this.flowContainer);
      this.accordionBtn.addEventListener('click', this.onAccordionClick);
    }

    disconnectedCallback() {
      this.intersectionObserver?.disconnect();
      this.accordionBtn?.removeEventListener('click', this.onAccordionClick);
    }

    onIntersect(entries) {
      entries.forEach((entry) => {
        if (entry.isIntersecting && !this.initialized) {
          this.initFlowbox();
        }
      });
    }

    async initFlowbox() {
      if (this.initialized) return;
      this.initialized = true;

      await loadFlowboxScript();

      window.flowbox('init', {
        container: `#${this.flowContainer.id}`,
        key: this.dataset.flowboxKey,
        locale: this.dataset.locale,
        productId: this.dataset.productId,
      });
    }

    onAccordionClick() {
      setTimeout(() => {
        if (this.accordionBtn.classList.contains('active')) {
          this.panel.classList.remove('is-closed');
          dispatchResizePasses();
        } else {
          this.panel.classList.add('is-closed');
        }
      }, 50);
    }
  }

  customElements.define('flowbox-tab', FlowboxTab);
})();
